import './Blocks/FloatMotion/BackgroundSwap/view/index.js';
import './Blocks/SyncMotion/view/index.js';
import './Blocks/Marquee/view/index.js';
import './Blocks/ImageMap/view/index.js';
import './Blocks/front.scss';

console.log(`[amplify-storytelling] Front module loaded.`);
